import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useMedia } from 'react-use'
import { gsap } from 'gsap'
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin'
import { SplitText } from 'gsap/SplitText'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(SplitText)
gsap.registerPlugin(MorphSVGPlugin)
window.requestAnimationFrame = window.requestAnimationFrame.bind(window) // Reqd for IE Edge in dev
gsap.registerPlugin(ScrollTrigger)

const SideBgLeft = (props) => {
    const isMobile = useMedia('(max-width: 992px)')
    const container = useRef(null)
    const scene1 = useRef(null)
    const scene2 = useRef(null)

    useEffect(() => {
        if (!isMobile && container.current) {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container.current,
                    start: 'top+=100 center',
                    end: '+=450',
                    scrub: 0.5
                }
            })
            tl.to(scene1.current, {
                morphSVG: {
                    shape: scene2.current,
                    type: 'linear'
                },
                ease: 'back.inOut(1)'
            })
        }
    }, [])

    return (
        <div ref={container} className='d-none d-lg-block' style={{ width: '100%', transform: 'scaleX(-1)' }}>
            <svg viewBox='0 0 406 1747'>
                <path ref={scene1} transform='translate(-1514.000000, -4278.000000)' fill='#F1FDF4' d='M1919.5224,4278 C1879.11543,4289.32396 1830.10917,4287.55165 1832.78842,4358.4843 C1841.8163,4597.49551 1593.89722,4542.14361 1593.89722,4752.4843 C1593.89722,5006.42001 1806.86698,4998.59845 1617.66106,5382.40058 C1535.65683,5548.74525 1478.49167,5716.75795 1539.61051,5826.92915 C1592.848,5922.89361 1746.16137,5967.50298 1919.07681,6024.26209 C1919.62851,5864.22127 1919.5224,4376.4843 1919.5224,4278 Z' />
                <path ref={scene2} d='M1929.78942,4193.89924 C1889.38245,4205.22319 1857.38332,4302.06735 1860.06258,4373 C1869.09045,4612.01121 1540.85859,4556.61979 1540.85859,4766.96047 C1540.85859,5020.89619 1897.44327,4970.20213 1708.23735,5354.00426 C1626.23312,5520.34893 1500.64121,5722.96047 1585.40666,5900.722 C1637.54658,6010.06456 1746.16137,6032.46003 1919.07681,6089.21914 C1919.62851,5929.17832 1929.78942,4292.38354 1929.78942,4193.89924 Z' />
            </svg>
        </div>
    )
}

SideBgLeft.propTypes = {}

export default SideBgLeft



// WEBPACK FOOTER //
// ./resources/js/components/SideBgLeft.js